import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { MediaDelete, MediaGet } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import Modal from "react-bootstrap/Modal";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import "./VideosGallery.css";
const VideosGallery = () => {
  const location = useLocation();
  const [Videodata, setVideodata] = useState([]);
  const myCompanyId = Cookies.get("company_id");
  const UserID = Cookies.get("userID");
  const galleryCompanyId =
    location.state?.company_id != null && location.state?.company_id !== ""
      ? String(location.state.company_id)
      : String(myCompanyId || "");
  const dispatch = useDispatch();
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [videoToDelete, setVideoToDelete] = useState(null);

  useEffect(() => {
    if (galleryCompanyId) {
      dispatch(MediaGet({ company_id: galleryCompanyId }));
    }
  }, [dispatch, galleryCompanyId]);

  const { media, loading } = useSelector((state) => state.GallerySlice);

  useEffect(() => {
    if (media?.result && media?.result?.length > 0) {
      const videoItems = media.result.filter(
        (item) => item.extension_type === "video"
      );

      setVideodata(videoItems);
    } else {
      setVideodata([]);
    }
  }, [media]);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const handleClose = () => {
    setSelectedVideo(null);
  };

  const handleDelete = async (id) => {
    try {
     
      const updatedVideos = Videodata.filter((video) => video.id !== id);
      await dispatch(MediaDelete({id:id}))
      setVideodata(updatedVideos);
    } catch (error) {
      console.error("Delete error:", error);
     
    }
  };                                                                           

  return (
    <>
      {loading && <Lodderr />}
      <motion.div
        className="vg-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="vg-hero">
          <div>
            <h1 className="vg-title">Videos</h1>
            <p className="vg-sub">A premium video gallery with smooth previews and actions.</p>
          </div>
          <span className="vg-pill">
            <i className="bx bx-video"></i> {Videodata.length} videos
          </span>
        </div>

        {Videodata.length > 0 ? (
          <div className="vg-grid">
            {Videodata.map((item, idx) => {
              const canDelete =
                Number(UserID) === Number(item?.member_id) &&
                Number(myCompanyId) === Number(item?.company_id);
              const title = item.title || item.tittle || "Untitled Video";
              return (
                <motion.div
                  key={item.id || idx}
                  className="vg-card"
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.2 }}
                  onClick={() => handleVideoClick({ src: item.file_url, title })}
                >
                  {canDelete && (
                    <button
                      className="vg-del"
                      onClick={(e) => {
                        e.stopPropagation();
                        setVideoToDelete(item.id);
                      }}
                      aria-label="Delete video"
                      type="button"
                    >
                      <i className="bx bx-trash"></i>
                    </button>
                  )}

                  <div className="vg-thumb">
                    <video src={item.file_url} muted playsInline />
                    <span className="vg-play">
                      <i className="bx bx-play"></i>
                    </span>
                  </div>
                  <div className="vg-cap">
                    <span className="vg-name" title={title}>{title}</span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        ) : (
          <div className="vg-empty">
            <i className="bx bx-video"></i>
            <p>No videos available.</p>
          </div>
        )}
      </motion.div>

      <Modal show={!!selectedVideo} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.title || "Video"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <video
            src={selectedVideo?.src}
            controls
            autoPlay
            className="img-fluid rounded w-100"
          ></video>
        </Modal.Body>
      </Modal>

      <ConfirmModal
        isOpen={!!videoToDelete}
        message="Are you sure you want to delete this video?"
        onCancel={() => setVideoToDelete(null)}
        onConfirm={() => {
          handleDelete(videoToDelete);
          setVideoToDelete(null);
        }}
      />
    </>
  );
};

export default VideosGallery;
